import apis from 'SERVICE/APIs';
import commonAction from 'ACTION/common/commonAction';
// ================================
// Action Type
// ================================
const FETCH_USERINFO = 'FETCH_USERINFO';
const FETCH_ALISERVICEURL = 'FETCH_ALISERVICEURL';
const FETCH_TTJURL = 'FETCH_TTJURL';
const FETCH_SSOTOKEN = 'FETCH_SSOTOKEN';
const FETCH_SETTING = 'FETCH_SETTING';
const FETCH_LOGOOUT = 'FETCH_LOGOOUT';
const FETCH_FINDLOGINPWD = 'FETCH_FINDLOGINPWD';
const FETCH_CHECKACCOUNT4FINDPWD = 'FETCH_CHECKACCOUNT4FINDPWD';
const GATWWAY_API = 'GATWWAY_API';
const QUERY_CARDLIST = 'QUERY_CARDLIST';
// ================================
// Action Creator
// ================================


const fetchUserInfo = params => dispatch => apis.User.GetUserInfo(params).then((msgs) => {
  dispatch({
    type: FETCH_USERINFO,
    payload: msgs,
  });
});

const qureyCardList = params => dispatch => apis.Wallet.QueryCardInfoList(params).then((msgs) => {
  dispatch({
    type: QUERY_CARDLIST,
    payload: msgs,
  });
	return msgs;
});


const fetchAliServiceUrl = params => dispatch => apis.Wechat.GetAliServiceUrl(params)
  .then((msgs) => {
    dispatch({
      type: FETCH_ALISERVICEURL,
      payload: msgs,
    });
  });

const fetchSetting = params => dispatch => apis.Common.Setting(params).then((msgs) => {
  dispatch({
    type: FETCH_SETTING,
    payload: msgs,
  });
});

const fetchLogoout = params => dispatch => apis.Common.Logoout(params).then((msgs) => {
  dispatch({
    type: FETCH_LOGOOUT,
    payload: msgs,
  });
});

const findLoginPassword = params => dispatch => apis.Fund.FindLoginPassword(params).then((msgs) => {
  dispatch({
    type: FETCH_FINDLOGINPWD,
    payload: msgs,
  });
});

const checkAccount4FindPwd = params => dispatch => apis.Fund.CheckAccount4FindPwd(params)
  .then((msgs) => {
    dispatch({
      type: FETCH_CHECKACCOUNT4FINDPWD,
      payload: msgs,
    });
  });

  const getGateWayApi = params => dispatch => apis.gateWayApi.GetGateWayApi(params)
  .then((msgs) => {
    dispatch({
      type: GATWWAY_API,
      payload: msgs,
    });
    return msgs;
});


/* default 导出所有 Action Creators */
export default {
  fetchUserInfo,
  fetchAliServiceUrl,
  fetchSetting,
  fetchLogoout,
  findLoginPassword,
  checkAccount4FindPwd,
  getGateWayApi,
  ...commonAction,
	qureyCardList
};

// ================================
// Action handlers for Reducer
// 本来更新 state 是 Reducer 的责任
// 但要把 ActionType 导出又引入实在太麻烦
// 且在 Reducer 中写 switch-case 实在太不优雅
// 故在此直接给出处理逻辑
// ================================
export const ACTION_HANDLERS = {
  [FETCH_USERINFO]: (result, { payload }) => {
    result.userInfo = payload;
    return result;
  },
  [FETCH_ALISERVICEURL]: (result, { payload }) => {
    result.aliService = payload;
    return result;
  },
  [FETCH_TTJURL]: (result, { payload }) => {
    result.ttjUrl = payload;
    return result;
  },
  [FETCH_SSOTOKEN]: (result, { payload }) => {
    result.ssoToken = payload;
    return result;
  },
  [FETCH_SETTING]: (result, { payload }) => {
    result.setting = payload;
    return result;
  },
  [FETCH_LOGOOUT]: (result, { payload }) => {
    result.logoout = payload;
    return result;
  },
  [FETCH_FINDLOGINPWD]: (result, { payload }) => {
    result.findLoginPwd = payload;
    return result;
  },
  [FETCH_CHECKACCOUNT4FINDPWD]: (result, { payload }) => {
    result.checkAccount = payload;
    return result;
  },
  [GATWWAY_API]: (result, { payload }) => ({ payload }),
  [QUERY_CARDLIST]: (result, { payload }) => {
    result.cardList = payload;
    return result;
  },
};



// WEBPACK FOOTER //
// ./src/redux/actions/h5/indexAction.js